export default __webpack_public_path__ + "static/media/Gloves.45497ed2.png";